import { useCallback, useEffect, useRef, useState } from "react"

// The transient "what just changed" chip on the mobile customiser.
//
// Every settings change on a phone happens behind the user's thumb, on a code
// small enough that a colour or corner tweak can be genuinely hard to see. The
// echo names the change in words for 1500ms so the control and its effect are
// never in doubt.
//
// The timer is cleared on unmount as well as on each new message — otherwise a
// change made immediately before navigating away sets state on a dead
// component.
export const ECHO_DURATION_MS = 1500

export default function useChangeEcho() {
  const [message, setMessage] = useState(null)
  const timer = useRef(null)

  const echo = useCallback((next) => {
    setMessage(next)
    clearTimeout(timer.current)
    timer.current = setTimeout(() => setMessage(null), ECHO_DURATION_MS)
  }, [])

  useEffect(() => () => clearTimeout(timer.current), [])

  return [ message, echo ]
}
